var map = {
	"./cashier.svg": [
		5572,
		191
	],
	"./chief.svg": [
		2851,
		851
	],
	"./employees.svg": [
		7511,
		511
	],
	"./google.svg": [
		5881,
		881
	],
	"./help-menu.svg": [
		1075,
		75
	],
	"./help.svg": [
		477,
		477
	],
	"./integrations.svg": [
		7429,
		429
	],
	"./patients.svg": [
		6790,
		790
	],
	"./pay.svg": [
		2974,
		974
	],
	"./phone.svg": [
		6872,
		872
	],
	"./price.svg": [
		9955,
		955
	],
	"./report.svg": [
		1770,
		770
	],
	"./rustore-blue.svg": [
		2888,
		507
	],
	"./rustore-white.svg": [
		8494,
		494
	],
	"./rustore.svg": [
		5810,
		810
	],
	"./schedule.svg": [
		2091,
		91
	],
	"./settings.svg": [
		587,
		587
	],
	"./sms.svg": [
		4611,
		611
	],
	"./tariffs.svg": [
		369,
		369
	],
	"./task.svg": [
		6771,
		771
	],
	"./time.svg": [
		4775
	],
	"./waiting.svg": [
		4481,
		481
	],
	"./warehouse.svg": [
		8125,
		125
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 9126;
module.exports = webpackAsyncContext;